import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const communicationsStakeholderGroupsRoute: InvariantJiraRoute = {
	name: 'communications-stakeholder-groups',
	path: '/jira/communications/stakeholder-groups',
};
